import axiosClient from "../axios-client";
import { getAllHeroSectionSuccess, getAllPageFooterSuccess, getAllPageHeaderSuccess } from "../reducers/bannersReducer";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================


export const getAllHeroSections = async (dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/hero-section/list`)
        .then((res) => {
            dispatch(getAllHeroSectionSuccess(res?.data || []))
        })
        .catch((error) => {
            toastMessage("Hero sections not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const getHeroSection = async (id, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/hero-section/details/${id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Hero section details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const getAllPageHeaders = async (dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/page-header/list`)
        .then((res) => {
            dispatch(getAllPageHeaderSuccess(res?.data || []))
        })
        .catch((error) => {
            toastMessage("Page header not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const getPageHeader = async (id, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/page-header/details/${id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Page header details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const getAllPageFooters = async (dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/page-footer/list`)
        .then((res) => {
            dispatch(getAllPageFooterSuccess(res?.data || []))
        })
        .catch((error) => {
            toastMessage("Page footer not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const getPageFooter = async (id, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/page-footer/details/${id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Page footer details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


// ===============================================================================
// =================================== POST API ===================================
// ===============================================================================


export const createHeroSection = async (data, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .post(`/hero-section/create`, data)
        .then((res) => {
            toastMessage("Hero section created successfully", "success")
        })
        .catch((error) => {
            toastMessage("Hero section creation failed due to an unexpected error", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const createPageHeader = async (data, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .post(`/page-header/create`, data)
        .then((res) => {
            toastMessage("Page header created successfully", "success")
        })
        .catch((error) => {
            toastMessage("Page header creation failed due to an unexpected error", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const createPageFooter = async (data, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .post(`/page-footer/create`, data)
        .then((res) => {
            toastMessage("Page footer created successfully", "success")
        })
        .catch((error) => {
            toastMessage("Page footer creation failed due to an unexpected error", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};



// ===============================================================================
// =================================== PUT API ===================================
// ===============================================================================


export const updatePageHeader = async (id, data, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .put(`/page-header/update/${id}`, data)
        .then((res) => {
            toastMessage("Page header updated successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Page header updation failed due to an unexpected error", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const updatePageFooter = async (id, data, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .put(`/page-footer/update/${id}`, data)
        .then((res) => {
            toastMessage("Page footer updated successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Page footer updation failed due to an unexpected error", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const updateHeroSection = async (id, data, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .put(`/hero-section/update/${id}`, data)
        .then((res) => {
            toastMessage("Hero section updated successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Hero section updation failed due to an unexpected error", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


// ===============================================================================
// =================================== DELETE API ================================
// ===============================================================================


export const deleteHeroSection = async (dispatch, id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .delete(`/hero-section/delete/${id}`)
        .then((res) => {
            toastMessage("Hero section deleted successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Hero section deletion failed", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const deletePageHeader = async (dispatch, id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .delete(`/page-header/delete/${id}`)
        .then((res) => {
            toastMessage("Page header deleted successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Page header deletion failed", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const deletePageFooter = async (dispatch, id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .delete(`/page-footer/delete/${id}`)
        .then((res) => {
            toastMessage("Page footer deleted successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Page footer deletion failed", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};
